import React, { ReactNode } from "react";
import { Tooltip as MUITooltip } from "@mui/material";

type TooltipProps = {
  children: ReactNode;
} & React.ComponentProps<typeof MUITooltip>;

const Tooltip = ({ children, ...props }: TooltipProps) => {
  return (
    <MUITooltip
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "12px",
            textAlign: "start",
            width: "fit-content",
            letterSpacing: 0.5,
            borderRadius: "8px",
            padding: "8px 10px",
            backgroundColor: "#404252",
            color: "#FFFFFF",
          },
        },
        arrow: {
          sx: {
            color: "#404252",
          },
        },
      }}
      {...props}
    >
      {children}
    </MUITooltip>
  );
};

export default Tooltip;
